<template>
  <lazy-table v-model="change_logs" model="change_logs" ref="table" :params="query">
    <table class="table table-hover table-responsive w-100 d-block d-md-table index-table">
      <thead>
        <tr>
          <sortable-th v-model="sort" sort_key="created_at">{{ 'time' | t }}</sortable-th>
          <sortable-th v-model="sort" sort_key="customer_name">{{ 'customer' | t }}</sortable-th>
          <sortable-th v-model="sort" sort_key="staff">{{ 'staff' | t }}</sortable-th>
          <sortable-th v-model="sort" sort_key="attr_name">{{ 'attr_name' | t }}</sortable-th>
          <sortable-th v-model="sort" sort_key="old_value">{{ 'old_value' | t }}</sortable-th>
          <sortable-th v-model="sort" sort_key="new_value">{{ 'new_value' | t }}</sortable-th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="log in change_logs">
          <td>{{ log.created_at | datetime }}</td>
          <td>{{ log.customer_name }}</td>
          <td>
            <p v-if="log.staff">{{ log.staff }}</p>
            <p v-else><i class="fa fa-cog mr-2"></i>System</p>
          </td>
          <td>{{ log.attr_name }}</td>
          <td>{{ log.old_value }}</td>
          <td>{{ log.new_value }}</td>
        </tr>
      </tbody>
    </table>
  </lazy-table>
</template>
<script>
import Api from '@/store/jsonapi';
export default {
  props: ['value', 'filter'],
  data: function () {
    return {
      change_logs: this.value,
      sort: '-created_at'
    };
  },
  computed: {
    query() {
      return {
        filter: this.filter,
        sort: this.sort
      };
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.$refs.table.load_debounce(true);
      }
    },
    query() {
      this.$refs.table.load_debounce(true);
    }
  }
};
</script>

<style scoped>
.index-table td {
  max-width: 110px;
}
</style>
